export default __webpack_public_path__ + "static/media/bbq-house-logo.6a07cf92.jpg";